import { Component, OnInit } from '@angular/core';
import { PropertiesService } from '../properties.service';

@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent implements OnInit {

  private pixelURL: string = '/lexip?pixel=43634534634&event=PageView';

  private facebookPixelId: string;
  private trackingCodes: string;
  private lastEvent: string = 'Select an Event';

  private displayError: boolean = false;

  private iframeEventCode: string = ``;
  private testUrl: string = ``;

  constructor(private properties: PropertiesService) {
    this.properties.currentMessage.subscribe((message: string) => {
      
      if (message === 'properties-loaded' || message === 'reload-icons') {
          this.loadCodes();
      }
    });
  }

  setTrackingCodes = (trackingCodes: string) => {
    
  }

  copy = () => {
    var copyText: any = document.getElementById("iframeCode");

    /* Select the text field */
    copyText.select();
    copyText.setSelectionRange(0, 99999); /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy");
  }

  testEvent = () => {
    var win = window.open(this.testUrl + '&test=true', '_blank');
    win.focus();
  }

  createEventCode = (event: string) => {
    if (!this.facebookPixelId) {
      this.displayError = true;
      return;
    }

    this.lastEvent = event;

    const url: string = this.properties.sanitizeDirtyUrl(this.properties.current.hostname, true) + '/lexip?pixel=' + this.facebookPixelId + '&event=' + event + '&property=' + this.properties.current._id;

    console.log(`Created iframe code for ${url}`);
    this.iframeEventCode = `
    <iframe src="${url}" width="1" height="1" frameborder="0" marginheight="0" marginwidth="0"></iframe>
    `;

    this.testUrl = url;
  }

  loadCodes = () => {
    if (this.properties.current && this.properties.current.template && this.properties.current.template.trackingCodes) {
      console.log('Loading tracking codes');
      this.trackingCodes = this.properties.current.template.trackingCodes;
    }
    
    if (this.properties.current && this.properties.current.template && this.properties.current.template.pixelCode) {
      console.log('Loading pixel codes');
      this.facebookPixelId = this.properties.current.template.pixelCode;
    }
  }

  ngOnInit() {
    this.loadCodes();
    
  }

}
